import { TYPE_STRING } from './input-types';

export const id = 'itemName';
export const apiKey = 'ItemName';
export const type = TYPE_STRING;

export const itemName = {
  id,
  apiKey,
  type,
};
